module.exports = __webpack_public_path__ + "static/media/custom-slide-img7.4232fa02.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/custom-slide-img7.png
// module id = 1054
// module chunks = 0